import React from 'react';
import { FormOutlined, UnorderedListOutlined } from '@ant-design/icons';
import AppIconGroup from '../../../components/app-icon-group';
import SwitchShop from '../../shop/switch-shop';
import CardTmpList from './tmp-list';
import { getCurrentShopId } from '../../shop/get-current-shop';

const iconStyle = {
    fontSize: 28,
}

export default () => {
    const [list, setList] = React.useState([]);

    React.useEffect(() => {
        getList().then(res => {
            setList(res);
        });
    }, []);
    const getList = async () => {
        const shopId = await getCurrentShopId();
        const response = await fetch(`/api/goods-card/list?shopId=${shopId}`);
        const result = await response.json();

        if(result?.success) {
            return result?.data?.rows;
        }else{
            return [];
        }
    };

    return (
        <div>
            <SwitchShop />
            
            {/* 快捷操作 - iOS 风格图标组 */}
            <div className="mt-3 mb-4">
                <AppIconGroup 
                    items={[
                        {
                            id: 1,
                            href: '/promotion/goods-card-template/create',
                            title: '创建次卡',
                            icon: <FormOutlined />,
                            color: 'from-blue-500 to-blue-600'
                        },
                        {
                            id: 2,
                            href: '/promotion/goods-card-list',
                            title: '次卡售卖明细',
                            icon: <UnorderedListOutlined />,
                            color: 'from-green-500 to-green-600'
                        }
                    ]}
                    cols="3-3-3-3-3"
                />
            </div>
            
            <h2 className="admin-page-title">次卡模版列表</h2>
            <CardTmpList cardList={list} />
        </div>
    )
}